import { render, staticRenderFns } from "./SelectOrderItem.vue?vue&type=template&id=0835b733&scoped=true&"
import script from "./SelectOrderItem.vue?vue&type=script&lang=js&"
export * from "./SelectOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835b733",
  null
  
)

export default component.exports